import CogsLocationBreakdownTable from "@src/components/shared-containers/CogsLocationBreakdown";
import { CustomCardWrapper } from "./style";

const CogsLocationBreakdown = () => {
  return (
    <CustomCardWrapper>
      <CogsLocationBreakdownTable pagination />
    </CustomCardWrapper>
  );
};

export default CogsLocationBreakdown;
